var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchUserAttributes } from 'aws-amplify/auth';
import { mapIdentity, emptyIdentity } from '../../models/identity';
import { getIdentity, getSlimIdentity } from '../../graphql/queries';
import { SET_IDENTITY } from './types';
import store from '../store';
import API from '../../graphql/createClient';
export function setIdentity(identity) {
    return {
        type: SET_IDENTITY,
        payload: identity,
    };
}
const grabIdentity = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const attributes = yield fetchUserAttributes();
        const id = attributes['custom:uid'];
        const res = yield API.graphql({ query: getIdentity, variables: { id } });
        const mapedidentity = mapIdentity(res);
        store.dispatch(setIdentity(mapedidentity));
        return false;
    }
    catch (err) {
        console.log('error grabIdentity');
        return true;
    }
});
const grabSlimIdentity = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const attributes = yield fetchUserAttributes();
        const id = attributes['custom:uid'];
        const res = yield API.graphql({ query: getSlimIdentity, variables: { id } });
        const mapedidentity = mapIdentity(res);
        store.dispatch(setIdentity(mapedidentity));
        return false;
    }
    catch (err) {
        console.log('error grabIdentity');
        return true;
    }
});
const removeIdentity = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        store.dispatch(setIdentity(emptyIdentity()));
    }
    catch (err) {
        console.log('error removeIdentity');
    }
});
export { grabIdentity, grabSlimIdentity, removeIdentity };
